import BstlArtikel from "@/entities/common/bstl_artikel"
import router from "@/router"
import RouteNames from "@/util/route_names"
import Formatter from "../formatter"
import BaseLogic from "../base_logic"
import BPArtikelAnzahlRequest from "@/entities/common/pending/bp_artikel_anzahl_request"
import vuexStore from "@/store"
import Poster from "@/util/poster"
import RemoteResult from "@/entities/common/remote_result"
import RestPaths from "@/util/rest_paths"

export default class WarenkorbLieferungLogic extends BaseLogic {
  mindestbestellwert: number = 0
  kostenlosAb: number = 0
  _lieferkosten: number = 0

  get warenkorb() {
    return this.mainLogic.bestellungPending.artikelliste
  }

  get weiterButtonDisabled(): boolean {
    var preisWarenkorb = Formatter.berechnePreisListe(this.warenkorb)
    return this.mindestbestellwert - preisWarenkorb > 0
  }

  init() {
    var nbd = this.mainLogic.bestellungPending
    this.mindestbestellwert = nbd.lieferung.mindestbestellwert
    this.kostenlosAb = nbd.lieferung.kostenlosAb
    this._lieferkosten = nbd.lieferung.lieferkosten
  }

  get lieferkosten(): number {
    var gesamtpreis = Formatter.berechnePreisListe(this.warenkorb)
    if (gesamtpreis >= this.kostenlosAb) {
      return 0
    } else {
      return this._lieferkosten
    }
  }

  goToShopping() {
    router.go(-1)
  }

  goToBestaetigen() {
    router.push({ name: RouteNames.NEU.KUNDENDATEN_LIEFERUNG })
  }

  increment(artikel: BstlArtikel) {
    var request = new BPArtikelAnzahlRequest()
    request.id = vuexStore.state.user.identifier
    request.artikelId = artikel.id
    request.anzahl = artikel.anzahl + 1

    Poster.postUser<RemoteResult<any>>(
      RestPaths.bestellungpendingArtikelAendern,
      request
    ).then((response) => {
      if (response.data.success) {
        artikel.anzahl += 1
      }
    })
  }

  decrement(artikel: BstlArtikel) {
    if (artikel.anzahl > 1) {
      var request = new BPArtikelAnzahlRequest()
      request.id = vuexStore.state.user.identifier
      request.artikelId = artikel.id
      request.anzahl = artikel.anzahl - 1

      Poster.postUser<RemoteResult<any>>(
        RestPaths.bestellungpendingArtikelAendern,
        request
      ).then((response) => {
        if (response.data.success) {
          artikel.anzahl -= 1
        }
      })
    }
  }

  remove(artikel: BstlArtikel) {
    var request = new BPArtikelAnzahlRequest()
    request.artikelId = artikel.id
    request.loeschen = true

    Poster.postUser<RemoteResult<any>>(
      RestPaths.bestellungpendingArtikelAendern,
      request
    ).then((response) => {
      if (response.data.success) {
        var index = this.mainLogic.bestellungPending.artikelliste.findIndex(
          (x) => {
            x.id === artikel.id
          }
        )
        if (index > -1) {
          this.mainLogic.bestellungPending.artikelliste.splice(index, 1)
        }

        this.warenkorb.splice(
          this.warenkorb.findIndex((x) => {
            return x.id === artikel.id
          }),
          1
        )
        if (this.warenkorb.length == 0) {
          router.go(-1)
        }
      }
    })
  }
}
